import { render, staticRenderFns } from "./DeleteProductUpdate.vue?vue&type=template&id=f0fdb648&"
import script from "./DeleteProductUpdate.vue?vue&type=script&lang=js&"
export * from "./DeleteProductUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports